module.exports = __webpack_public_path__ + "static/computer-95f46c8c23a2532d11aac391cc02af5c.png";